import useCart from 'modules/cart/util/use-cart';
import React from 'react';
import CartAction from './cart-action';
import {IoCard} from 'react-icons/io5';
import {useNavigate} from 'react-router-dom';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {Switch} from '@mantine/core';
import {MdAttachMoney} from 'react-icons/md';

const CartPayment: React.FC = () => {
  const {cart, setRetainedEarnings} = useCart();
  const {companyId} = useAccessControls();
  const navigate = useNavigate();

  return (
    <>
      <CartAction
        {...{
          title: 'Forma de pagamento',
          description: cart?.payment
            ? cart?.payment.name
            : 'Pague pelo app ou na entrega',
          buttonLabel: cart?.payment ? 'Trocar' : 'Adicionar',
          icon: <IoCard size={26} />,
          onClick: () => navigate(`${companyId}/payment-methods`),
        }}
      />
      <CartAction
        {...{
          title: 'Dinheiro com a empresa?',
          description: 'Informe com quem está o dinheiro',
          buttonLabel: cart?.retainedEarnings ? 'Sim' : 'Não',
          icon: <MdAttachMoney size={26} />,
          onClick: () => setRetainedEarnings(!cart?.retainedEarnings),
          extraComponent: (
            <Switch
              checked={!!cart?.retainedEarnings}
              style={{pointerEvents: 'none'}}
            />
          ),
        }}
      />
    </>
  );
};

export default CartPayment;
